import React, { useEffect, useState } from 'react';
import { Title, Text, ScrollArea, Skeleton } from '@mantine/core';
import { useQuery } from '@apollo/client';

import { ProofOfCompetitorPricing } from '../../codegen/graphql';
import ProofOfPricingCard from './ProofOfPricingCard';
import ProofOfPricingModal from './components/ProofOfPricingModal';
import { GET_PROOF_OF_PRICING_FOR_REQUEST } from '../../apollo/queries/priceChangeRequest';

type Props = {
    requestId: string | null;
};

function RequestProofOfPricing({ requestId }: Props) {
    const [opened, setOpened] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const {
        data: proofData,
        loading: proofLoading,
        refetch,
    } = useQuery(GET_PROOF_OF_PRICING_FOR_REQUEST, {
        variables: { requestId: requestId! },
        skip: !requestId,
        fetchPolicy: 'network-only',
    });

    const documents: ProofOfCompetitorPricing[] =
        proofData?.getProofOfPricingForRequest ?? [];

    const openGallery = (_selectedIndex: number) => {
        setOpened(true);
        setSelectedIndex(_selectedIndex);
    };

    useEffect(() => {
        if (opened) {
            refetch();
        }
    }, [opened]);

    const renderContent = () => {
        if (proofLoading) {
            return (
                <div className="flex flex-col w-full gap-4">
                    <Skeleton height={56} radius="md" />
                    <Skeleton height={56} radius="md" />
                </div>
            );
        }

        if (documents.length > 0) {
            return (
                <ScrollArea
                    classNames={{
                        root: 'flex flex-col flex-1',
                    }}
                >
                    {documents.map((proof, index) => (
                        <ProofOfPricingCard
                            key={proof.id}
                            proofOfPricing={proof}
                            openGallery={() => openGallery(index)}
                        />
                    ))}
                    <div>
                        <ProofOfPricingModal
                            open={opened}
                            documents={documents}
                            initialIndex={selectedIndex}
                            onClose={() => setOpened(false)}
                        />
                    </div>
                </ScrollArea>
            );
        }

        return (
            <div className="flex h-36 items-center justify-center w-full">
                <Text className="text-sm text-center font-medium">
                    No Proof of Pricing
                </Text>
            </div>
        );
    };

    return (
        <div className="flex flex-col flex-1 mt-10 gap-5">
            <Title order={4}>Proof of Pricing</Title>
            <div className="flex w-full items-center gap-8">
                {renderContent()}
            </div>
        </div>
    );
}

export default RequestProofOfPricing;
